import React, { useRef,useEffect,useState } from "react";
import { Button } from "primereact/button";

const FileUploadBtn = ({
  type,
  apiUrl,
  fetchMethodRequest,
  getDataFromServer,
  showToasterMessage,
  toast,
  routeTo,
  uploadUrl,
  screenName,
}) => {
  const fileInputRef = useRef(null);
  const [screenKeyWords,setScreenKeyWords]=useState([])


    useEffect(() => {
        getScreensData();

    }, []);

    const getScreensData = async () => {
        const url = `dynamicScreens`;
        const resp = await fetchMethodRequest('GET', url);
        try {
          if (resp && resp.dynamicScreens) {
            const smartScreensData = resp?.dynamicScreens[0]?.smartBuilderScreens || []
            let specifiedKeywords =smartScreensData.filter(item=>item.name===screenName)[0]?.fields.map(item=>item.name)||[];           
            setScreenKeyWords(specifiedKeywords);
        }
        } catch (error) {
          console.log("error",error);
        }
    }
  const getUploadUrl = () => {
    if (type === "invoice") {
      return `${apiUrl}/reviewInvoice`;
    }
    else if (type === "agreement") {
      return `${apiUrl}/reviewAgreement`;
    }
    else if (type === "companyData") {
      return `${apiUrl}/reviewCompanyData`;
    }
    else if (type === "Other Documents") {
      return `${apiUrl}/reviewOtherDocuments`;
    }
    else if (uploadUrl) {
      return uploadUrl;
    }
    else {
      return `${apiUrl}/upload`;
    }
  };

  const handleFileChange = async (event) => {
    const files = Array.from(event.target.files || []);
    if (!files.length) return;

    // reset input
    event.target.value = null;

    const uploadUrl = getUploadUrl();

    showToasterMessage(
      `Processing ${files.length} ${type === "invoice"
        ? "Invoices"
        : type === "agreement"
          ? "Contracts"
          : "Files"
      }...`,
      "loading"
    );

    try {
      const formData = new FormData();
      for (const file of files) {
        formData.append("file", file);
        formData.append("screenKeyWords", screenKeyWords);
      }

      const response = await fetchMethodRequest(
        "POST",
        uploadUrl,
        formData,
        undefined,
        undefined,
        routeTo
      );

      if (response?.respMessage) {
        getDataFromServer?.();

        setTimeout(() => {
          toast.update("loader-toast", {
            render:
              response.respMessage ||
              `${files.length} file(s) processed successfully!`,
            type: "success",
            isLoading: false,
            autoClose: 3000,
          });
        }, 100);

      } else {
        throw new Error("Processing failed");
      }

    } catch (err) {
      console.error("Upload error:", err);

      setTimeout(() => {
        toast.update("loader-toast", {
          render: "Failed to process files. Please try again.",
          type: "error",
          isLoading: false,
          autoClose: 5000,
        });
      }, 100);
    }
  };

  return (
    <div className="file-upload-container">
      <input
        type="file"
        multiple
        accept=".pdf,.docx"
        onChange={handleFileChange}
        ref={fileInputRef}
        style={{ display: "none" }}
      />

      <Button
        icon="pi pi-upload"
        size="small"
        onClick={() => fileInputRef.current?.click()}
      />
    </div>
  );
};

export default FileUploadBtn;
